import EnumItem, { enumMixn } from '../../../enums/enumItem';

/**
 * 模板类型  访问级别
 */
let EnumPriorityLevel = {
    1: new EnumItem('1', 1),
    2: new EnumItem('2', 2),
    3: new EnumItem('3', 3),
    4: new EnumItem('4', 4),
    5: new EnumItem('5', 5),
    6: new EnumItem('6', 6),
    7: new EnumItem('7', 7),
    8: new EnumItem('8', 8),
    9: new EnumItem('9', 9),
    10: new EnumItem('10', 10),
    204: new EnumItem('204', 204),
    ...enumMixn,
};
export default EnumPriorityLevel;
